export const PlayArrowIcon = () => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      className="block m:hidden"
    >
      <g filter="url(#filter0_d_643_183001)">
        <path
          d="M19 1C10.1634 1 3 8.16344 3 17C3 25.8366 10.1634 33 19 33C27.8366 33 35 25.8366 35 17C35 12.7565 33.3143 8.68687 30.3137 5.68629C27.3131 2.68571 23.2435 1 19 1Z"
          fill="white"
        />
        <g clipPath="url(#clip0_643_183001)">
          <path
            d="M25.5 16.134C26.1667 16.5189 26.1667 17.4811 25.5 17.866L16.5 23.0622C15.8333 23.4471 15 22.966 15 22.1962L15 11.8038C15 11.034 15.8333 10.5529 16.5 10.9378L25.5 16.134Z"
            fill="#00AED9"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_643_183001"
          x="0"
          y="0"
          width="38"
          height="38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0941176 0 0 0 0 0.207843 0 0 0 0 0.345098 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_643_183001"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_643_183001"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_643_183001">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(11 9)"
          />
        </clipPath>
      </defs>
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
      className="hidden m:block"
    >
      <g filter="url(#filter0_d_643_179315)">
        <path
          d="M43 1C20.9086 1 3 18.9086 3 41C3 63.0914 20.9086 81 43 81C65.0914 81 83 63.0914 83 41C83 30.3913 78.7857 20.2172 71.2843 12.7157C63.7828 5.21427 53.6087 1 43 1Z"
          fill="white"
        />
        <g clipPath="url(#clip0_643_179315)">
          <path
            d="M53.5 40.134C54.1667 40.5189 54.1667 41.4811 53.5 41.866L38.5 50.5263C37.8333 50.9112 37 50.4301 37 49.6603L37 32.3397C37 31.5699 37.8333 31.0888 38.5 31.4737L53.5 40.134Z"
            fill="#00AED9"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_643_179315"
          x="0"
          y="0"
          width="86"
          height="86"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0941176 0 0 0 0 0.207843 0 0 0 0 0.345098 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_643_179315"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_643_179315"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_643_179315">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(31 29)"
          />
        </clipPath>
      </defs>
    </svg>
  </>
);
